import type { GeographyTaxonomyPreference } from '../../../../shared/user-preferences/utils/geography-preference';
import { defineSingleValueFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

/**
 * Aliases the stored-preference shape rather than declaring a twin: a second
 * structural type would keep compiling after the canonical one drifts.
 */
export type CustomGeographyTaxonomySelection = GeographyTaxonomyPreference;

/**
 * `taxonomyId: 0` means "no opinion", NOT metro. A link that omits the filter
 * and a link that explicitly names metro have to stay distinguishable: only the
 * second may override the viewer's own preference. Defaulting to
 * `MSA_GEOGRAPHY_TAXONOMY_ID` would collapse them and leave metro links
 * rendering under an administrative viewer's taxonomy.
 */
export const geographyTaxonomyDescriptor =
  defineSingleValueFilter<CustomGeographyTaxonomySelection>()({
    definition: {
      id: FilterId.GEOGRAPHY_TAXONOMY,
      name: 'Geography Taxonomy',
      value: { taxonomyId: 0 },
      type: FilterType.VALUE,
      isVisible: false,
      isActive: true,
    },
  });
